/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import React, {useMemo} from 'react';
import {BolmateSelect} from "../../controls";
import {NotificationInterval} from "../../../util/enums";
import {BolmateSelectItem} from "../../../util/interfaces";
import Notification from "../../../models/notificationModel";

const intervalItems: Array<BolmateSelectItem> = [
    {value: '', label: 'Wanneer', selectable: false},
    {value: NotificationInterval.DAY, label: 'dag', info: 'Gebundeld per dag.'},
    {value: NotificationInterval.WEEK, label: 'week', info: 'Gebundeld per week.'},
    {value: NotificationInterval.MONTH, label: 'maand', info: 'Gebundeld per maand.'},
];

interface Props {
    onChangeNotification: (notification: Notification) => void;
    disabled: boolean;
    notification: Notification;
    withRealtime?: boolean;
}

export default function NotificationIntervalComp(props: Props) {
    const {onChangeNotification, notification, disabled, withRealtime} = props;
    const selectItems: Array<BolmateSelectItem> = useMemo(() => {
        const items = intervalItems.slice();
        if (withRealtime) items.splice(1, 0,
            {
                value: NotificationInterval.INSTANT, label: 'direct',
                info: 'Notificaties worden realtime verzonden.'
            });
        return items;
    }, [withRealtime]);

    function onChange(value: NotificationInterval) {
        notification.interval = value;
        onChangeNotification(notification);
    }

    return (
        <section>
            <label className='fixed-text'>per</label>
            <BolmateSelect value={notification.interval} onChange={onChange} items={selectItems}
                           className='select-field' disabled={disabled}/>
        </section>
    )
}